import React, { useState } from 'react';
import Recently_added_dropdown from '../dropdown/recently_added_dropdown';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from 'react-accessible-accordion';
import useTranslation from "next-translate/useTranslation";

const Collection_category_filter = ({ setSaleType, setSortBy }) => {
	const {t, lang} = useTranslation('collection')
	const [propertiesModal, setPropertiesModal] = useState(false);
	const [propetiesAccordionValue, setPropetiesAccordionValue] = useState(null);
	// const [SaleType, setSaleType] = useState("");
	// const [sortBy, setSortBy] = useState("");

	const handlePropartiesAccordion = (parentId, e) => {
		setPropetiesAccordionValue(parentId);
		const target = e.target.closest('.accordion-item');
		target.classList.toggle('show-accordion');
	};

	const sortText = [
		{
			id: 1,
			text: t('recent_add'),
			value: "RECENT",
		},
		{
			id: 2,
			text: t('price_l_h'),
			value: "LOW",
		},
		{
			id: 3,
			text: t('price_h_l'),
			value: "HIGH",
		},
	];
	const blockchainText = [
		{
			id: 2,
			text: 'Polygon',
		},
	];
	// const categoryText =[];

	const saleTypeText = [{
		id: 0,
		text: t('all_sale'),
		value: ""
	},
	{
		id: 1,
		text: t('auction'),
		value: "BID"
	},
	{
		id: 2,
		text: t('fixed_price'),
		value: "FIXED"
	},
	{
		id: 3,
		text: t('not_sale'),
		value: "NOTSALE"
	},
	];

	// const propertiesText = [
	// 	{
	// 		parentId: 1,
	// 		titleText: 'Background',
	// 		properties: [
	// 			{
	// 				id: 1,
	// 				color: 'red',
	// 				point: '14',
	// 			},
	// 			{
	// 				id: 2,
	// 				color: 'green',
	// 				point: '56',
	// 			},
	// 			{
	// 				id: 3,
	// 				color: 'blue',
	// 				point: '11',
	// 			},
	// 			{
	// 				id: 4,
	// 				color: 'white',
	// 				point: '25',
	// 			},
	// 		],
	// 	},
	// 	{
	// 		parentId: 2,
	// 		titleText: 'Eyes',
	// 		properties: [
	// 			{
	// 				id: 1,
	// 				color: 'red',
	// 				point: '14',
	// 			},
	// 			{
	// 				id: 2,
	// 				color: 'green',
	// 				point: '56',
	// 			},
	// 			{
	// 				id: 3,
	// 				color: 'blue',
	// 				point: '11',
	// 			},
	// 			{
	// 				id: 4,
	// 				color: 'white',
	// 				point: '25',
	// 			},
	// 		],
	// 	},
	// 	{
	// 		parentId: 3,
	// 		titleText: 'face',
	// 		properties: [
	// 			{
	// 				id: 1,
	// 				color: 'red',
	// 				point: '14',
	// 			},
	// 			{
	// 				id: 2,
	// 				color: 'green',
	// 				point: '56',
	// 			},
	// 			{
	// 				id: 3,
	// 				color: 'blue',
	// 				point: '11',
	// 			},
	// 			{
	// 				id: 4,
	// 				color: 'white',
	// 				point: '25',
	// 			},
	// 		],
	// 	},
	// ];

	return (
		<>
			{/* <!-- Filter --> */}
			<div className="mb-8 flex flex-wrap items-center justify-between">
				<div className="flex flex-wrap items-center">
					{/* <!-- Blockchain --> */}
					<Recently_added_dropdown data={blockchainText} dropdownFor="blockchain" />

					{/* <!-- Category --> */}
					{/* <Recently_added_dropdown data={categoryText} dropdownFor="category" /> */}

					{/* <!-- Properties --> */}
					<div className="my-1 mr-2.5">
						{/* <button
							className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
							onClick={() => setPropertiesModal(true)}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="24"
								height="24"
								className="fill-jacarta-700 dark:fill-jacarta-100 mr-1 h-4 w-4 transition-colors group-hover:fill-white"
							>
								<path fill="none" d="M0 0h24v24H0z"></path>
								<path d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17z"></path>
							</svg>
							<span>Properties</span>
						</button> */}

						{/* <!-- Properties Modal --> */}
						{/* ===CODE DELETED== */}
						{/* <!-- end properties modal --> */}

					</div>

					{/* <!-- Sale Type --> */}
					<Recently_added_dropdown data={saleTypeText} dropdownFor="sale-type" setSaleType={(data) => setSaleType(data)} />

					{/* <!-- Price Range --> */}
					{/* <Recently_added_dropdown data={saleTypeText} dropdownFor="price-range" /> */}
				</div>

				{/* <!-- Sort --> */}
				<Recently_added_dropdown data={sortText} dropdownFor="recently_added" setSortBy={(data) => setSortBy(data)} />
			</div>
		</>
	);
};

export default Collection_category_filter;
